import { CartResponse } from 'src/items-list/business-logic/service/interfaces/cart-response';
import { LineItemStatus } from '../../common/enumerations/line-item-status';
import { PromotionApprovalStatus } from '../../common/enumerations/promotion-approval-status';
import { showPromotionApprovalDialog } from '../../promotion-approval/promotion-approval';
import { applyCartResponse } from './common/apply-cart-response';
import { IPromotionApproval, promotionApproval } from './service/promotion-approval';

export const getPromotionApprovals = async (transaction: CartResponse): Promise<void> => {
  const transactionId = transaction.cartId ?? '';
  if (transaction.rewards) {
    const pendingRewards = transaction.rewards.filter(
      reward =>
        reward.status !== LineItemStatus.Cancelled &&
        reward.approval?.status === PromotionApprovalStatus.PendingApproval,
    );
    const promotionsToUpdate: IPromotionApproval[] = [];
    for (const reward of pendingRewards) {
      if (reward.approval?.message) {
        const result: { isApproved: boolean; authorizedCount?: number } = await new Promise(
          resolvePromotion => {
            showPromotionApprovalDialog({
              approvalMessage: reward.approval?.message ?? '',
              pendingRedemptionCount: reward.approval?.pendingAuthRedemption ?? 0,
              resolvePromotion,
            });
          },
        );
        promotionsToUpdate.push({
          sequenceNumber: reward.lineId ?? 0,
          promotionId: reward.promotionId ?? '',
          approvalStatus: result.isApproved ? 'Approved' : 'Rejected',
          pendingAuthorizationRedemptionCount: reward.approval?.pendingAuthRedemption ?? 0,
          authorizedRedemptionCount: result.isApproved ? result.authorizedCount || 1 : 0,
        });
      }
    }
    if (promotionsToUpdate.length > 0) {
      await promotionApproval(transactionId, promotionsToUpdate).then(applyCartResponse);
    }
  }
};
